import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import userReducer from "../reducer/userReducer";
// import letReducer from "../reducer/letReducer";
import chatReducer from "..//reducer/chatReducer";
import payrollReducer from "..//reducer/payrollReducer";
import templateBuilderReducer from "../reducer/templateBuilderReducer";
import maintenanceReducer from "../reducer/maintenanceReducer";
import thunk from "redux-thunk";
const mainReducer = combineReducers({
  user: userReducer,
  chat: chatReducer,
  payroll:payrollReducer,
  maintenance: maintenanceReducer,
  templateBuilder: templateBuilderReducer
});
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  mainReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
